<template>
	<div>
		<div
			class="nav"
			:class="navBgShow ? 'navShow':''"
		>
			<div class="zhong nav-content">
				<img
					class="nav-left"
					src="../assets/logo1.png"
					mode=""
				/>
				<div class="nav-right">
					<div
						class="item"
						v-for="item in navList"
						:key="item.id"
						@click="navTo(item.link)"
					>{{item.title}}</div>
				</div>
			</div>
		</div>
		<div class="banner_swiper">
			<swiper :options="bannerOption">
				<swiper-slide
					v-for="item in 3"
					:key="item.id"
				>
					<img
						class="banner"
						src="../assets/banner.jpg"
					/>
				</swiper-slide>
			</swiper>
		</div>
		<div class="solution zhong">
			<div class="home-title">解决方案</div>
			<div class="solution-list">
				<div
					class="solution-box"
					:class="solutionShow ? 'flipInY':''"
					v-for="item in solutionList"
					:key="item.id"
				>
					<img
						class="nav-left"
						:src="item.img"
						mode=""
					/>
					<div class="title">{{item.title}}</div>
					<div class="desc">{{item.content}}</div>
					<div class="move">
						<div class="move-title">{{item.title}}</div>
						<div class="move-desc">{{item.content}}</div>
						<img
							src="../assets/rightshow.png"
							alt=""
						>
					</div>
				</div>
			</div>
		</div>
		<div class="product">
			<img
				class="product-bg"
				src="../assets/bg1.jpg"
				mode=""
			/>
			<div class="product-container zhong">
				<div class="home-title">产品中心</div>
				<div class="product-nav">
					<div
						class="item"
						v-for="(item,index) in productObj.nav"
						:key="item.id"
						:class="productOption.activeIndex == index? 'active':'' "
						@click="swiperClick(index)"
					>{{item}}</div>
				</div>
				<swiper
					:options="productOption"
					class="swiper1"
				>
					<swiper-slide
						v-for="item in productObj.arr"
						:key="item.id"
					>
						<div
							class="product-content"
							:class="productShow? 'flash':''"
						>
							<div
								class="box"
								v-for="item in item.productList"
								:key="item.id"
							>
								<img
									class="nav-left"
									:src="item.img"
									mode=""
								/>
								<div class="title">{{item.title}}</div>
							</div>
						</div>
					</swiper-slide>
				</swiper>
				<div class="product-button">
					<div
						class="product-prev"
						:class="!productOption.isBeginning ?'active':'none'"
					>
						<img
							:src="productOption.isBeginning ? lefthide: leftshow"
							alt=""
						>
					</div>
					<div
						class="product-next"
						:class="!productOption.isEnd ?'active':'none'"
					>
						<img
							:src="productOption.isEnd ? righthide: rightshow"
							alt=""
						>
					</div>
				</div>
			</div>

		</div>
		<div
			class="service zhong"
			:class="serviceShow ? 'backInLeft':''"
		>
			<div class="home-title">服务支持</div>
			<!--<div class="service-desc">XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</div>-->
			<div class="service-list">
				<div
					class="box"
					v-for="item in serviceList"
					:key="item.id"
				>
					<img
						class="nav-left"
						:src="item.img"
						mode=""
					/>
					<div class="cylindrical">
						<div class="circle">{{item.title}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="company">
			<img
				class="company-bg"
				src="../assets/bg2.jpg"
				mode=""
			/>
			<div
				class="zhong"
				:class="companyShow? 'bounceInRight':'company-none'"
			>
				<div class="home-title">公司简介</div>
				<div class="company-content">
					<img
						src="../assets/12.png"
						mode=""
					/>
					<div>
						<p>深圳云智汇网络科技有限公司成立于2015年，团队来自华为、腾讯、施耐德电气等世界 500 强公司，擅长整合传统产业与互联网优势资源，方案策划，运营咨询，体系培训，软硬件开发。以“引领未来智能生活”为核心，专注于智能家居、可穿戴设备、人工智能等诸多科技前沿领域，致力于智能创新对人的生活方式价值的改变，多维度为用户及厂商提供服务。<br/><br/>公司使命：用心做好每一款产品。</p>
					</div>
				</div>
			</div>
		</div>
		<div class="partner zhong">
			<div class="home-title">合作案例</div>
			<div class="partner-nav">
				<div
					class="item"
					v-for="(item,index) in partnerList"
					:key="item.id"
					@click="partnerClick(index)"
				>
					<img
						:src="partnerIndex == index ?item.selectedimg:item.unselectedimg"
						mode=""
					/>
				</div>
			</div>
			<div class="partner-content">
				<img
					class="left"
					:src="partnerList[partnerIndex].banner"
					alt=""
				>
				<div class="right">
					<div class="title">{{partnerList[partnerIndex].title}}</div>
					<div class="desc">{{partnerList[partnerIndex].desc}}</div>
					<div class="detail">{{partnerList[partnerIndex].detail}}</div>
				</div>
			</div>
		</div>
		<div class="foolter">
			<img
				class="foolter-bg"
				src="../assets/bg3.jpg"
				mode=""
			/>
			<div class="zhong foolter-content">
				<div class="foolter-box1">
					<div class="title">业务联系</div>
					<img
						class="babel"
						src="../assets/33.png"
						mode=""
					/>
					<img
						class="logo"
						src="../assets/logo.png"
						mode=""
					/>
					<div class="detail">用心做好每一款产品</div>
				</div>
				<div class="foolter-box2">
					<div class="title">快速导航</div>
					<img
						class="babel"
						src="../assets/33.png"
						mode=""
					/>
					<div class="text">解决方案</div>
					<div class="text">产品中心</div>
					<div class="text">服务支持</div>
					<!-- <div class="text">公司简介</div> -->
				</div>
				<div class="foolter-box2">
					<div class="title">电话联系</div>
					<img
						class="babel"
						src="../assets/33.png"
						mode=""
					/>
					<div class="text">吴先生<br/>13516656769</div>
				</div>
				<div class="foolter-box2">
					<div class="title">微信联系</div>
					<img
						class="babel"
						src="../assets/33.png"
						mode=""
					/>
					<img
						class="code"
						src="../assets/32.png"
						mode=""
					/>
				</div>
				
			</div>

			<div style="text-align: center;padding-bottom: 10px;background-color: #081118;color: #c4c4c4">
			Copyright © 2020 深圳市云智汇网络科技有限公司
			<br/>
			备案号：<a href="http://beian.miit.gov.cn" target="_blank" style="color: #2966fe;text-decoration:none;">粤ICP备18098876号</a>
		</div>
		</div>
		</div>
	</div>
</template>
<script>
import Mock from "./mock";
import options from "./options";
let timer = null;
import leftshow from "../assets/leftShow.png";
import lefthide from "../assets/lefthide.png";
import rightshow from "../assets/rightshow.png";
import righthide from "../assets/righthide.png";
export default {
	data() {
		return {
			...Mock,
			...options,
			navBgShow: false,
			scrollTop: 0,
			mySwiper: null,
			leftshow,
			lefthide,
			rightshow,
			righthide,
			partnerIndex: 0,
			solutionShow: false,
			productShow: false,
			serviceShow: false,
			companyShow: false,
		};
	},
	mounted() {
		this.mySwiper = new Swiper(".swiper1", {
			onSlideChangeStart: (swiper) => {
				console.log(swiper);
				this.productOption.isBeginning = swiper.isBeginning;
				this.productOption.isEnd = swiper.isEnd;
				this.productOption.activeIndex = swiper.activeIndex;
			},
		});
		this.isBeginning = this.mySwiper.isBeginning;
		this.isEnd = this.mySwiper.isEnd;
		window.addEventListener("scroll", this.handleScroll);
	},
	destroyed() {
		window.removeEventListener("scroll", this.handleScroll);
	},

	methods: {
		handleScroll(e) {
			if (!timer) {
				timer = setTimeout(() => {
					timer = null;
					this.scrollTop =
						window.pageYOffset ||
						document.documentElement.scrollTop ||
						document.body.scrollTop;
					if (this.scrollTop > 400) this.solutionShow = true;
					if (this.scrollTop > 900) this.productShow = true;
					if (this.scrollTop > 1600) this.serviceShow = true;
					if (this.scrollTop > 2200) this.companyShow = true;
					if (this.scrollTop > 600) {
						this.navBgShow = true;
					}
					if (this.scrollTop < 600) {
						this.navBgShow = false;
					}
				}, 300);
			}
		},
		swiperClick(index) {
			this.mySwiper.slideTo(index, 1000, true);
		},
		partnerClick(index) {
			this.partnerIndex = index;
		},
		navTo(link){
				window.scrollTo(0, link);
		}
	},
};
</script>

<style lang="less">
.zhong {
	margin: auto;
	width: 1200px;
}
.home-title {
	font-size: 36px;
	color: #060606;
}
.nav {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 22;
	height: 100px;
	.nav-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 100%;
	}
	.nav-left {
		width: 156px;
		height: 48px;
	}
	.nav-right {
		width: 70%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.item {
			color: #fff;
			font-size: 20px;
		}
	}
}
.banner_swiper {
	min-width: 1200px;
	display: flex;
	.banner {
		width: 100%;
		height: 900px;
		object-fit: cover;
	}
}
.solution {
	padding: 50px 0 0 0;
	.solution-list {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 50px;
		.solution-box {
			opacity: 0;
			width: 366px;
			height: 236px;
			background-color: #ffffff;
			border-radius: 5px;
			border: solid 1px #005eff;
			padding: 26px 52px;
			margin-bottom: 40px;
			position: relative;
			img {
				width: 60px;
				height: 54px;
			}
			.title {
				font-size: 18px;
				color: black;
				margin: 19px 0 15px 0;
			}
			.desc {
				font-size: 14px;
				color: #212121;
			}
			.move {
				opacity: 0;
			}
		}
		.solution-box:hover {
			position: relative;

			.move {
				transition: all 0.3s;

				z-index: 4;
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-color: #195afe;
				opacity: 0.93;
				color: #fff;
				padding: 38px 42px 22px 42px;
				.move-title {
					font-size: 24px;
					border-bottom: 1px solid #fff;
					padding-bottom: 20px;
					margin-bottom: 20px;
				}
				.move-desc {
					font-size: 14px;
					margin-bottom: 20px;
				}
				img {
					width: 30px;
					height: 30px;
					float: right;
				}
			}
		}
	}
}
.product {
	position: relative;
	z-index: 2;
	padding: 68px 0 0 0;
	height: 745px;
	.product-bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 745px;
		z-index: -1;
	}
	.product-container {
		position: relative;
		.product-nav {
			display: flex;
			align-items: center;
			margin-top: 20px;
			border-bottom: 1px solid #999;
			.item {
				font-size: 18px;
				color: #434343;
				width: 180px;
				height: 60px;
				line-height: 60px;
			}
			.active {
				font-size: 26px;
				color: #195afe;
				position: relative;
			}
			.active::after {
				content: "";
				position: absolute;
				bottom: 0;
				left: 0;
				width: 70%;
				height: 2px;
				background: #195afe;
			}
		}
		.product-content {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			margin-top: 50px;
			padding: 0 10px;
			opacity: 0;
			.box {
				width: 287px;
				height: 221px;
				background-color: #ffffff;
				padding: 26px 52px;
				margin-bottom: 20px;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				box-shadow: 1px 1px 10px 0px #bbbbbb;
				img {
					width: 211px;
					height: 146px;
				}
				.title {
					font-size: 15px;
					color: #000000;
					margin-top: 10px;
				}
			}
		}
		.product-button {
			position: absolute;
			top: 0;
			right: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			.active {
				background: #195afe;
			}
			.none {
				border: 1px solid #195afe;
			}
			div:first-child {
				width: 40px;
				height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				img {
					width: 60%;
					height: 60%;
				}
			}
			div:last-child {
				width: 40px;
				height: 40px;

				display: flex;
				justify-content: center;
				align-items: center;
				img {
					width: 60%;
					height: 60%;
				}
			}
		}
	}
}
.service {
	padding: 70px 0 90px 0;
	opacity: 0;
	.service-desc {
		font-size: 20px;
		color: #333232;
		margin: 30px 0 60px 0;
	}
	.service-list {
		display: flex;
		justify-content: space-between;
		.box {
			width: 288px;
			height: 408px;
			position: relative;
			img {
				width: 100%;
				height: 100%;
			}
			.cylindrical {
				width: 123px;
				height: 119px;
				background-color: rgba(41, 102, 254, 0.2);

				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				z-index: 4;
				border-radius: 50%;
				.circle {
					width: 113px;
					height: 109px;
					background-color: #2966fe;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					z-index: 6;
					color: #fff;
					border-radius: 50%;
					opacity: 1;
					text-align: center;
					line-height: 109px;
				}
			}
		}
	}
}
.company {
	position: relative;
	z-index: 2;
	padding: 68px 0 0 0;
	height: 745px;
	.company-none{
		opacity: 0;
	}
	.company-bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 687px;
		z-index: -1;
	}
	.company-content {
		display: flex;
		justify-content: space-between;
		margin-top: 45px;
		img {
			width: 653px;
			height: 428px;
		}
		div {
			width: 500px;
			font-size: 18px;
			color: #333232;
		}
	}
}
.partner {
	padding-bottom: 90px;
	.partner-nav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 45px;
		.item {
			width: 384px;
			height: 97px;
			border: solid 1px #9e9e9e;
			display: flex;
			justify-content: center;
			align-items: center;
			img {
				width: 223px;
				height: 64px;
			}
		}
	}
	.partner-content {
		display: flex;
		justify-content: space-between;
		margin-top: 60px;
		.left {
			width: 541px;
			height: 376px;
		}
		.right {
			width: 600px;
			.title {
				font-size: 26px;

				color: #0f0f0f;
			}
			.desc {
				font-size: 18px;
				color: #252525;
			}
			.detail {
				font-size: 18px;
				color: #252525;
			}
		}
	}
}
.foolter {
	position: relative;
	z-index: 2;
	padding-top: 110px;
	.foolter-bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 442px;
		z-index: -1;
	}
	.foolter-content {
		display: flex;
		.foolter-box1 {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			width: 500px;
			.title {
				font-size: 36px;
				color: #e2e2e2;
			}
			.babel {
				width: 80px;
				height: 14px;
				margin: 22px 0 30px -10px;
			}
			.logo {
				width: 204px;
				height: 75px;
				margin-left: -20px;
			}
			.detail {
				width: 330px;
				margin-top: 35px;
				font-size: 17px;
				color: #b9b9b9;
				line-height: 30px;
			}
		}
		.foolter-box2 {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			width: 330px;
			flex: 1;
			.title {
				font-size: 19px;
				color: #cccccc;
			}
			.babel {
				width: 80px;
				height: 14px;
				margin: 22px 0 30px -10px;
			}
			.text {
				font-size: 17px;
				color: #cccccc;
				line-height: 50px;
			}
			.code {
				width: 201px;
				height: 201px;
			}
		}
	}
}
.navShow {
	animation-name: navShowBackGround;
	animation-duration: 1s;
	animation-fill-mode: forwards;
	background-image: linear-gradient(90deg, #2d3ca7, #5765c9);
}
@keyframes navShowBackGround {
	from {
		transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
		animation-timing-function: ease-in;
		opacity: 0;
	}

	40% {
		transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
		animation-timing-function: ease-in;
	}

	60% {
		transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
		opacity: 1;
	}

	80% {
		transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
	}

	to {
		transform: perspective(400px);
	}
}
@keyframes flipInY {
	from {
		transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
		animation-timing-function: ease-in;
		opacity: 0;
	}

	40% {
		transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
		animation-timing-function: ease-in;
	}

	60% {
		transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
		opacity: 1;
	}

	80% {
		transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
	}

	to {
		transform: perspective(400px);
	}
}

.flipInY {
	opacity: 1 !important;
	backface-visibility: visible !important;
	animation-name: flipInY;
	animation-duration: 1s;
	animation-fill-mode: forwards;
}
@keyframes backInUp {
	0% {
		transform: translateY(1200px) scale(0.7);
		opacity: 0.7;
	}

	80% {
		transform: translateY(0px) scale(0.7);
		opacity: 0.7;
	}

	100% {
		transform: scale(1);
		opacity: 1;
	}
}

.flash {
	animation-name: backInUp;
	animation-duration: 1s;
	animation-fill-mode: forwards;
	opacity: 1 !important;
}
@keyframes backInLeft {
	0% {
		transform: translateX(-2000px) scale(0.7);
		opacity: 0.7;
	}

	80% {
		transform: translateX(0px) scale(0.7);
		opacity: 0.7;
	}

	100% {
		transform: scale(1);
		opacity: 1;
	}
}

.backInLeft {
	opacity: 1 !important;

	animation-name: backInLeft;
	animation-duration: 1s;
	animation-fill-mode: forwards;
}
@keyframes bounceInRight {
	from,
	60%,
	75%,
	90%,
	to {
		animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
	}

	from {
		opacity: 0;
		transform: translate3d(3000px, 0, 0) scaleX(3);
	}

	60% {
		opacity: 1;
		transform: translate3d(-25px, 0, 0) scaleX(1);
	}

	75% {
		transform: translate3d(10px, 0, 0) scaleX(0.98);
	}

	90% {
		transform: translate3d(-5px, 0, 0) scaleX(0.995);
	}

	to {
		transform: translate3d(0, 0, 0);
	}
}

.bounceInRight {
	opacity: 1 !important;
	animation-name: bounceInRight;
	animation-duration: 1s;
	animation-fill-mode: forwards;
}
</style>


// WEBPACK FOOTER //
// src/view/Home.vue